"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as o } from "react";
import m from "../components/Icon/SvgIcon.js";
const e = (a) => /* @__PURE__ */ l(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.356 7.201 6.83 5.021l.422-.296.422-.295 1.527 2.179zm2.227-.797L8.698 3.713l.823-.576a.624.624 0 1 0-.717-1.024l-1.334.934v.001l-.935.654-2.269 1.589a.624.624 0 1 0 .717 1.023l.823-.576L7.691 8.43a.623.623 0 0 0 .87.153l1.868-1.309a.624.624 0 0 0 .154-.87m4.054 10.668-.737-.244-4.652-6.735-.04-.05 2.38-1.644.024.04.01.015 4.654 6.733-.021.734zm4.757 4.338-2.43-3.47-.013-.013-.003-.002-.005-.005.255-.178c.154-.107.213-.319.11-.476l-.263-.374.188-.133a.62.62 0 0 0 .262-.49l.034-1.148a1 1 0 0 0-.172-.57l-4.351-6.293.055-.038a.627.627 0 0 0 .158-.87l-.393-.567a.623.623 0 0 0-.868-.159L7.417 9.762a.626.626 0 0 0-.158.871l.393.565a.627.627 0 0 0 .869.158l.054-.038 4.35 6.3c.12.171.287.297.49.367l1.13.373a.64.64 0 0 0 .559-.085l.245-.175.253.363c.109.156.309.18.466.072l.27-.19.003.007.001.005q.002.008.007.015l2.43 3.47a.375.375 0 1 0 .615-.43m-7.25-10.064.473-.332a.2.2 0 0 0 .049-.278l-.331-.473a.2.2 0 0 0-.279-.05l-.473.332a.2.2 0 0 0-.049.28l.331.471a.2.2 0 0 0 .279.05m1.594 1.27-.473.332a.2.2 0 0 1-.278-.05l-.332-.472a.2.2 0 0 1 .05-.279l.472-.332a.2.2 0 0 1 .28.05l.331.473a.2.2 0 0 1-.05.278m.648 1.934.474-.332a.2.2 0 0 0 .05-.278l-.332-.473a.2.2 0 0 0-.279-.05l-.473.332a.2.2 0 0 0-.049.279l.331.472a.2.2 0 0 0 .278.05",
        clipRule: "evenodd"
      }
    )
  }
), r = o(e);
export {
  r as Covid19Info,
  r as default
};
